export const GET_STATIC_PROPS_ERROR = 'GET_STATIC_PROPS_ERROR';
export const TRACK_THIS_PAGE_VIEW = 'TRACK_THIS_PAGE_VIEW';
//# sourceMappingURL=constants.js.map